import type { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import type { IWallet } from '../../account/store/account.store';
import { selectWallets } from '../../account/store/account.store';
import { useLayout } from '../../main/util/layout-context';
import { createClassName, createStyleHelper } from '../../shared/utils/class-names';
import { CrabPromoItem } from '../components/crab-promo-item';

import styles from './crab-promo.module.scss';

const style = createStyleHelper(styles, 'crab-promo');
export interface CrabPromo {
    className?: string;
}

export const CrabPromo: FunctionComponent<CrabPromo> = ({ className }) => {
    useLayout({
        title: 'CrabPromo',
        showNavButtons: true,
        isFullWidth: true,
    });
    const wallets = useSelector(selectWallets);
    const mainWallet = wallets?.filter((wallet: IWallet) => wallet.type === 'main');
    console.log(mainWallet);
    console.log(
        mainWallet && mainWallet[0]?.aggregates?.['monetary-credit']?.['Counter'],
        'monetary credit',
        'aggregates with c Capital',
    );
    console.log(
        mainWallet && mainWallet[0]?.aggregates?.['monetary-credit']?.Counter,
        'monetary credit',
        'aggregates with .Counter',
    );
    console.log(
        mainWallet && mainWallet[0]?.aggregates?.['monetary-credit']?.counter,
        mainWallet && mainWallet[0]?.aggregates?.['monetary-credit']?.counter === 1,
        'monetary credit',
        'aggregates with .counter ',
    );

    return (
        <>
            {/*{prompt}*/}
            <div className={createClassName([className, style()])}>
                <h1 className={style('label')}>PROMOTIONS</h1>
                <h6 className={style('blurb')}>{/*Placeholder*/}</h6>
                <CrabPromoItem />
            </div>
        </>
    );
};
